import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      isDataLoading: false,
      createProfile: {
        showAvatarCropModal: false,
        avatarFile: null,
        form: {
          name: {
            type: 'input',
            name: 'name',
            label: 'Full name *',
            placeholder: 'Full name',
            validation: [{ name: 'required' }],
            value: null,
            class: 'col-6 pr-12px'
          },
          employment_type: {
            type: 'select',
            name: 'employment_type',
            label: 'Employment type *',
            placeholder: 'Select employment type',
            valueField: 'id',
            selectLabel: 'name',
            options: [],
            value: null,
            class: 'col-md-6 pl-12px',
            validation: [{ name: 'required' }],
            labelClass: 'text-lowercase'
          },
          partner: {
            type: 'select',
            name: 'partner_id',
            label: 'Partner name *',
            placeholder: 'Select partner name',
            valueField: 'id',
            selectLabel: 'company_name',
            value: null,
            class: 'col-md-12',
            hidden: true,
            options: [],
            validation: [{ name: 'required' }],
            skipValidation: (fields) => fields.employment_type.value?.id !== 'partner'
          },
          allocations: {
            type: 'multiselect',
            name: 'allocations',
            nameItem: 'allocations',
            label: 'Allocation *',
            placeholder: 'Select allocation',
            valueField: 'id',
            selectLabel: 'name',
            value: [],
            class: 'col-md-6 pr-12px',
            options: [],
            labelClass: 'text-lowercase',
            validation: [{ name: 'required' }]
          },
          payment_type: {
            type: 'select',
            name: 'payment_type',
            label: 'Payment type *',
            placeholder: 'Select payment type',
            options: [],
            value: null,
            class: 'col-md-6 pl-12px',
            labelClass: 'text-lowercase',
            validation: [{ name: 'required' }]
          },
          years_of_experience: {
            type: 'input',
            typeInput: 'number',
            name: 'years_of_experience',
            label: 'Years of experience *',
            placeholder: 'Years of experience',
            validation: [{ name: 'required' }],
            value: null,
            class: 'col-6 pr-12px'
          },
          availability: {
            type: 'select',
            name: 'availability',
            label: 'Availability *',
            placeholder: 'Select availability',
            valueField: 'id',
            selectLabel: 'name',
            value: null,
            class: 'col-md-6 pl-12px',
            options: [],
            labelClass: 'text-lowercase',
            validation: [{ name: 'required' }]
          },
          seniority_lvl: {
            type: 'select',
            name: 'seniority_lvl',
            label: 'Seniority level *',
            placeholder: 'Select seniority level',
            valueField: 'id',
            selectLabel: 'name',
            value: null,
            class: 'col-md-6 pr-12px',
            options: [],
            labelClass: 'text-lowercase',
            validation: [{ name: 'required' }]
          },
          english_lvl: {
            type: 'select',
            name: 'english_lvl',
            label: 'English level *',
            placeholder: 'Select english level',
            valueField: 'id',
            selectLabel: 'name',
            value: null,
            class: 'col-md-6 pl-12px',
            options: [],
            validation: [{ name: 'required' }],
            labelClass: 'text-lowercase'
          },
          position: {
            type: 'input',
            name: 'position',
            label: 'Position *',
            placeholder: 'Position',
            validation: [{ name: 'required' }],
            value: null,
            class: 'col-6 pr-12px'
          },
          cv_link: {
            type: 'input',
            name: 'cv_link',
            label: 'CV',
            placeholder: 'Link to CV',
            value: null,
            class: 'col-6 pl-12px'
          }
        }
      },
      createInvite: {
        showAvatarCropModal: false,
        avatarFile: null,
        form: {
          name: {
            type: 'input',
            name: 'name',
            label: 'Full name',
            placeholder: 'Full name',
            value: null,
            class: 'col-6 pr-12px full-name'
          },
          employment_type: {
            type: 'select',
            name: 'employment_type',
            label: 'Employment type *',
            placeholder: 'Select employment type',
            validation: [{ name: 'required' }],
            valueField: 'id',
            selectLabel: 'name',
            options: [],
            value: null,
            class: 'col-md-6 pl-12px',
            labelClass: 'text-lowercase'
          },
          partner: {
            type: 'select',
            name: 'partner_id',
            label: 'Partner name *',
            placeholder: 'Select partner name',
            valueField: 'id',
            selectLabel: 'company_name',
            value: null,
            class: 'col-md-12',
            hidden: true,
            options: [],
            validation: [{ name: 'required' }],
            skipValidation: (fields) => fields.employment_type.value?.id !== 'partner'
          },
          allocations: {
            type: 'multiselect',
            name: 'allocations',
            nameItem: 'allocations',
            label: 'Allocation *',
            placeholder: 'Select allocation',
            validation: [{ name: 'required' }],
            valueField: 'id',
            selectLabel: 'name',
            value: [],
            class: 'col-md-6 pr-12px',
            options: [],
            labelClass: 'text-lowercase'
          },
          payment_type: {
            type: 'select',
            name: 'payment_type',
            label: 'Payment type *',
            placeholder: 'Select payment type',
            validation: [{ name: 'required' }],
            options: [],
            value: null,
            class: 'col-md-6 pl-12px',
            labelClass: 'text-lowercase'
          },
          years_of_experience: {
            type: 'input',
            typeInput: 'number',
            name: 'years_of_experience',
            label: 'Years of experience',
            placeholder: 'Years of experience',
            value: null,
            class: 'col-6 pr-12px'
          },
          availability: {
            type: 'select',
            name: 'availability',
            label: 'Availability',
            placeholder: 'Select availability',
            valueField: 'id',
            selectLabel: 'name',
            value: null,
            class: 'col-md-6 pl-12px',
            options: [],
            labelClass: 'text-lowercase'
          },
          seniority_lvl: {
            type: 'select',
            name: 'seniority_lvl',
            label: 'Seniority level',
            placeholder: 'Select seniority level',
            valueField: 'id',
            selectLabel: 'name',
            value: null,
            class: 'col-md-6 pr-12px',
            options: [],
            labelClass: 'text-lowercase'
          },
          english_lvl: {
            type: 'select',
            name: 'english_lvl',
            label: 'English level',
            placeholder: 'Select english level',
            valueField: 'id',
            selectLabel: 'name',
            value: null,
            class: 'col-md-6 pl-12px',
            options: [],
            labelClass: 'text-lowercase'
          },
          position: {
            type: 'input',
            name: 'position',
            label: 'Position',
            placeholder: 'Position',
            value: null,
            class: 'col-6 pr-12px'
          },
          cv_link: {
            type: 'input',
            name: 'cv_link',
            label: 'CV',
            placeholder: 'Link to CV',
            value: null,
            class: 'col-6 pl-12px'
          }
        }
      },
      editProfile: {
        showModal: false,
        showAvatarCropModal: false,
        showConvertIntoUserModal: false,
        avatarFile: null,
        form: {
          'id': {
            name: 'id',
            value: null,
            hidden: true
          },
          'name': {
            type: 'input',
            name: 'name',
            label: 'Full name',
            placeholder: 'Full name',
            value: null,
            class: 'col-6'
          },
          'employment_type': {
            type: 'select',
            name: 'employment_type',
            label: 'Employment type',
            placeholder: 'Select employment type',
            selectLabel: 'name',
            valueField: 'id',
            options: [],
            value: null,
            class: 'col-md-6',
            labelClass: 'text-lowercase'
          },
          'partner': {
            type: 'select',
            name: 'partner_id',
            label: 'Partner name',
            placeholder: 'Select partner name',
            valueField: 'id',
            options: [],
            selectLabel: 'company_name',
            value: null,
            class: 'col-md-12',
            hidden: true,
            validation: [{ name: 'required' }],
            skipValidation: (fields) => fields.employment_type.value?.id !== 'partner'
          },
          allocations: {
            type: 'multiselect',
            name: 'allocations',
            nameItem: 'allocations',
            label: 'Allocation',
            placeholder: 'Select allocations',
            valueField: 'id',
            selectLabel: 'name',
            value: [],
            class: 'col-6',
            options: [],
            labelClass: 'text-lowercase'
          },
          'payment_type': {
            type: 'select',
            name: 'payment_type',
            label: 'Payment type',
            placeholder: 'Select payment type',
            options: [],
            value: null,
            class: 'col-md-6',
            labelClass: 'text-lowercase'
          },
          years_of_experience: {
            type: 'input',
            typeInput: 'number',
            name: 'years_of_experience',
            label: 'Years of experience',
            placeholder: 'Select years of experience',
            value: 3,
            class: 'col-6'
          },
          availability: {
            type: 'select',
            name: 'availability',
            label: 'Availability',
            placeholder: 'Select availability',
            selectLabel: 'name',
            valueField: 'id',
            value: null,
            class: 'col-6',
            options: [],
            labelClass: 'text-lowercase'
          },
          seniority_lvl: {
            type: 'select',
            name: 'seniority_lvl',
            label: 'Seniority level',
            placeholder: 'Select seniority level',
            selectLabel: 'name',
            valueField: 'id',
            value: null,
            class: 'col-6',
            options: [],
            labelClass: 'text-lowercase'
          },
          english_lvl: {
            type: 'select',
            name: 'english_lvl',
            label: 'English level',
            placeholder: 'Select english level',
            selectLabel: 'name',
            valueField: 'id',
            value: null,
            class: 'col-6',
            options: [],
            labelClass: 'text-lowercase'
          },
          'position': {
            type: 'input',
            name: 'position',
            label: 'Position',
            placeholder: 'Position',
            value: null,
            class: 'col-6'
          },
          cv_link: {
            type: 'input',
            name: 'cv_link',
            label: 'CV',
            placeholder: 'Link to CV',
            value: null,
            class: 'col-6'
          },
          skills: {
            type: 'slot',
            slotName: 'skills',
            name: 'skills',
            label: 'Skills',
            placeholder: 'Select skills',
            class: 'col-12',
            value: []
          }
        }
      }
    }
  },
  async mounted () {
    await this.fetchAllData()
  },
  computed: {
    ...mapGetters({
      getAllocations: 'users/getAllocations',
      getAvailability: 'users/getAvailability',
      getEmploymentTypes: 'users/getEmploymentTypes',
      getEnglishLevels: 'users/getEnglishLevels',
      getPaymentTypes: 'users/getPaymentTypes',
      getSeniorityLevels: 'users/getSeniorityLevels',
      getAllPartners: 'partners/getAllPartners'
    })
  },
  watch: {
    getAllocations: {
      handler (values) {
        if (values && values.length) {
          this.createProfile.form.allocations.options = values
          this.createInvite.form.allocations.options = values
          this.editProfile.form.allocations.options = values
        }
      },
      immediate: true
    },
    getAvailability: {
      handler (values) {
        if (values && values.length) {
          this.createProfile.form.availability.options = values
          this.createInvite.form.availability.options = values
          this.editProfile.form.availability.options = values
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      fetchAllocations: 'users/fetchAllocations',
      fetchAvailability: 'users/fetchAvailability',
      fetchEmploymentTypes: 'users/fetchEmploymentTypes',
      fetchEnglishLevels: 'users/fetchEnglishLevels',
      fetchPaymentTypes: 'users/fetchPaymentTypes',
      fetchSeniorityLevels: 'users/fetchSeniorityLevels'
    }),
    async loadAllocations () {
      await this.fetchAllocations()
    },
    async loadAvailability () {
      await this.fetchAvailability()
    },
    async loadEmploymentTypes () {
      await this.fetchEmploymentTypes()
    },
    async loadEnglishLevels () {
      await this.fetchEnglishLevels()
    },
    async loadPaymentTypes () {
      await this.fetchPaymentTypes()
    },
    async loadSeniorityLevels () {
      await this.fetchSeniorityLevels()
    },
    async loadAllPartners () {
      await this.$api.partners.getAllPartners()
    },
    setVisibleEditModal (status) {
      this.editProfile.showModal = status
    },
    async fetchAllData () {
      return Promise.all([
        this.loadAllocations(),
        this.loadAvailability(),
        this.loadEmploymentTypes(),
        this.loadEnglishLevels(),
        this.loadPaymentTypes(),
        this.loadSeniorityLevels(),
        this.loadAllPartners()
      ])
        .then(() => {
          this.setAllOptions()
          this.setDefaultValues()
        })
    },
    setAllOptions () {
      this.createProfile.form.allocations.options = this.getAllocations
      this.createInvite.form.allocations.options = this.getAllocations
      this.editProfile.form.allocations.options = this.getAllocations

      this.createProfile.form.availability.options = this.getAvailability
      this.createInvite.form.availability.options = this.getAvailability
      this.editProfile.form.availability.options = this.getAvailability

      this.createProfile.form.employment_type.options = this.getEmploymentTypes
      this.createInvite.form.employment_type.options = this.getEmploymentTypes
      this.editProfile.form.employment_type.options = this.getEmploymentTypes

      this.createProfile.form.english_lvl.options = this.getEnglishLevels
      this.createInvite.form.english_lvl.options = this.getEnglishLevels
      this.editProfile.form.english_lvl.options = this.getEnglishLevels

      this.createProfile.form.payment_type.options = this.getPaymentTypes.map(item => item.id)
      this.createInvite.form.payment_type.options = this.getPaymentTypes.map(item => item.id)
      this.editProfile.form.payment_type.options = this.getPaymentTypes.map(item => item.id)

      this.createProfile.form.seniority_lvl.options = this.getSeniorityLevels
      this.createInvite.form.seniority_lvl.options = this.getSeniorityLevels
      this.editProfile.form.seniority_lvl.options = this.getSeniorityLevels

      this.createProfile.form.partner.options = this.getAllPartners
      this.createInvite.form.partner.options = this.getAllPartners
      this.editProfile.form.partner.options = this.getAllPartners
    },
    setDefaultValues () {
      this.createInvite.form.employment_type.value = this.createInvite.form.employment_type.options.find(option => option?.id === 'team_member' || option === 'team_member') || null
      this.createInvite.form.allocations.value = [this.createInvite.form.allocations.options.find(option => option?.id === 'full_time' || option === 'full_time')] || null
      this.createInvite.form.payment_type.value = this.createInvite.form.payment_type.options.find(option => option?.id === 'monthly' || option === 'monthly') || null
    },
    handleAvatarFile (e, form) {
      const file = e.target.files[0]

      if (!file) return

      if (file.type.indexOf('image/') === -1) {
        this.$snotify.error('Please select an image file', 'Error', this.$store.state.snotify)
        return
      }

      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          switch (form) {
            case 'createProfile':
              this.createProfile.avatarFile = event.target.result
              this.createProfile.showAvatarCropModal = true
              break
            case 'createInvite':
              this.createInvite.avatarFile = event.target.result
              this.createInvite.showAvatarCropModal = true
              break
            case 'editProfile':
              this.editProfile.avatarFile = event.target.result
              this.editProfile.showAvatarCropModal = true
              break
          }
        }

        reader.readAsDataURL(file)
      } else {
        this.$snotify.error('Sorry, FileReader API not supported', 'Error', this.$store.state.snotify)
      }
    },
    resetAvatarInputAfterModalClose () {
      if (this.$refs.avatarFile?.value) {
        this.$refs.avatarFile.value = null
      }
      this.createInvite.avatarFile = null
      this.createProfile.avatarFile = null
      this.editProfile.avatarFile = null
    },
    fillEditUserForm (user) {
      this.editProfile.form.id.value = user.id
      this.editProfile.form.name.value = user.name
      this.editProfile.form.position.value = user.position
      this.editProfile.form.payment_type.value = user.payment_type
      this.editProfile.form.employment_type.value = user.employment_type
      this.editProfile.form.partner.value = user.partner
      this.editProfile.form.partner.hidden = user.employment_type.type !== 'partner'
      this.editProfile.form.availability.value = user.availability
      this.editProfile.form.years_of_experience.value = user.years_of_experience
      this.editProfile.form.seniority_lvl.value = user.seniority_lvl
      this.editProfile.form.english_lvl.value = user.english_lvl
      this.editProfile.form.cv_link.value = user.cv_link
      this.editProfile.form.allocations.value = user.allocations
      this.editProfile.form.skills.value = user.skills
    },

    prepareDataForRequest (fields) {
      let data = {}

      for (let key in fields) {
        const field = fields[key]
        const fieldName = field['name']
        let fieldValue = fields[key]['value']

        if (Array.isArray(fieldValue) && key !== 'skills') {
          fieldValue = fieldValue.map(
            (item) => item[fields[key]['valueField']]
          )
        } else if (typeof fieldValue === 'object' && fieldValue) {
          let fieldKey = fields[key]['valueField']
          fieldValue = fieldKey
            ? fieldValue[fields[key]['valueField']]
            : fieldValue
        }

        data[fieldName] = fieldValue
      }
      if (fields['employment_type'] && fields['employment_type']['value'] && fields['employment_type']['value']['id'] !== 'partner') {
        delete data['partner_id']
      }

      return data
    },
    fetchUser (id) {
      return this.$api.users.getUser(id)
    },
    fetchUserProfile (id) {
      return this.$api.users.getUserProfile(id)
    },
    async updateUser (data) {
      const userId = data.id.value
      const formData = this.prepareDataForRequest(data)
      const savedUser = await this.$api.users.updateUser(userId, formData)
      this.setVisibleEditModal(false)
      return savedUser
    },
    async updateProfile (data) {
      const profileId = data.id.value
      const formData = this.prepareDataForRequest(data)
      const savedUser = await this.$api.users.updateUserProfile(profileId, formData)
      this.setVisibleEditModal(false)
      return savedUser
    }
  }
}
